import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import React from 'react'

interface RefreshAssetsDialogProps {
  open: boolean
  starting: boolean
  onCancel: () => void
  onConfirm: () => void
}

// Confirms a "Refresh Available Assets" before enqueuing it (DRI-246). A refresh is a full re-sync of
// every Business Manager the user administers against Facebook, spending the app-wide API quota every
// Marketing Milk job shares, so it should only be used when an asset is known to be missing.
const RefreshAssetsDialog = ({ open, starting, onCancel, onConfirm }: RefreshAssetsDialogProps) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>Refresh available assets?</DialogTitle>
    <DialogContent>
      <p>
        This re-syncs every Ad Account and Page from each Facebook Business Manager you&apos;re an
        admin on. It can take several minutes and uses a large amount of Facebook API capacity
        shared across Marketing Milk.
      </p>
      <Alert severity="warning">
        Only refresh if you&apos;re certain an Ad Account or Page should be listed but isn&apos;t.
        Otherwise, please reach out to Marketing Milk support.
      </Alert>
      <p className="mt-3 mb-0">
        You can keep working while it runs. The lists update when it finishes.
      </p>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={starting}>
        Cancel
      </Button>
      <Button onClick={onConfirm} color="primary" variant="contained" disabled={starting}>
        {starting ? 'Starting...' : 'Refresh'}
      </Button>
    </DialogActions>
  </Dialog>
)

export default RefreshAssetsDialog
